import React from 'react';
import heroImg from '../assets/hero.jpg';
import logo from '../assets/logoms.PNG'; // optionnel


export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="container hero-grid">
        <div className="hero-left">
          <img src={logo} alt="logo" />
          <h1>MS Multiservices - <br/>Votre partenaire pour tous vos travaux et services</h1>
          <p>Entreprise basée à Marseille, spécialisée dans le multiservices, nous intervenons pour le bricolage, plomberie, électricité, entretien, travaux intérieurs et extérieurs, et dépannage pour particuliers et professionnels. Disponible 24h/24, 7j|7, même jours fériés, avec un devis rapide en moyenne sous 24h, nous sommes votre partenaire fiable et réactif.</p>
          <a className="btn-primary" href="#contact">Obtenir un devis</a>
        </div>
        <div className="hero-right">
          <img src={heroImg} alt="Technicien multiservice" />
        </div>
      </div>
    </section>
  );
}
